import React from "react";
import TermTooltip from "@/components/TermTooltip";

export default function EventsPanel({ events }) {
  if (!events) return null;
  const csd = events.CSD || [];
  const bm = events.BM;
  const faf = events.FAF || [];
  const irl = events.IRL;
  const aab = events.AAB;

  return (
    <div className="panel p-4 space-y-3" data-testid="events-panel">
      <div className="panel-title text-[14px] mb-2">Signaux Structurels</div>

      <EventRow code="CSD" label="Changement de Structure Dynamique" value={
        csd.length ? `${csd.length} événement(s) — dernier : ${csd[csd.length - 1].direction}` : "aucun"
      } />
      <EventRow code="BM" label="Biais de Marché" value={bm ? `Bascule ${bm.direction}` : "aucune"} highlight={!!bm} />
      <EventRow code="IRL" label="Indice de Retournement Local" value={irl ? `Retournement ${irl.direction}` : "aucun"} highlight={!!irl} />
      <EventRow code="FAF" label="Force d'Accélération Future" value={
        faf.length ? faf[faf.length - 1].session : "hors fenêtre"
      } />
      <EventRow code="AAB" label="Action Algorithmique de Base" value={
        aab ? `Prix dans la moitié ${aab.zone} (mère H=${aab.mother_high.toFixed(5)} L=${aab.mother_low.toFixed(5)})` : "n/a"
      } />
    </div>
  );
}

function EventRow({ code, label, value, highlight }) {
  return (
    <div className={`flex items-start gap-3 px-2 py-1.5 rounded-md ${highlight ? "bg-accent-blue/10 border border-accent-blue/30" : ""}`}>
      <div className="font-mono text-[11px] px-1.5 py-0.5 border border-white/15 rounded bg-white/5 text-white/80 mt-0.5">{code}</div>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] text-white/50 flex items-center gap-1">
          <TermTooltip term={code}><span>{label}</span></TermTooltip>
        </div>
        <div className="text-xs text-white/85">{value}</div>
      </div>
    </div>
  );
}
